import React from "react";
import "./TermList.css";
import { dictionaryTerms } from "../data/dictionaryData";

const TermList = () => {
  return (
    <>
      <h2 className="dictionary-header">Słowniczek pojęć</h2>
      <div className="term-list">
        {dictionaryTerms.map((item) => {
          const { id, term, explanation } = item;
          return (
            <div key={id} className="single-term">
              <p className="term">{term}</p>
              <p className="explanation">{explanation}</p>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default TermList;
